import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import dashboardService from "../../services/dashboardService";
import {
  FETCH_DASHBOARD_FILTERED_BATCH_LIST,
  FETCH_DATA,
  FETCH_PRODUCTS_AND_SITES,
  GENERATE_KPI_TABLE,
  FETCH_TABLE_PLOT_STATE,
  GENERATE_KPI_GRAPH,
  SET_SELECTED_BATCH_IDS
} from "./types";
// import * as types from "./types";

// const service = new GenealogyService();



export const setSelectedBatchIds = (ids) => ({
  type: SET_SELECTED_BATCH_IDS,
  payload: ids,
});

export const fetchProductAndSites = () => async (dispatch) => {
  dispatch({
    type: FETCH_PRODUCTS_AND_SITES,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await dashboardService.fetchProductAndSites();
    dispatch({
      type: FETCH_PRODUCTS_AND_SITES,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PRODUCTS_AND_SITES,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchData = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_DATA,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await dashboardService.fetchData(requestData);
    dispatch({
      type: FETCH_DATA,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_DATA,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

// export const genearateKpiTable = (requestData) => async (dispatch) => {
//   dispatch({
//     type: GENERATE_KPI_TABLE,
//     payload: { ...initialState?.apiStatus, loader: true },
//   });
//   try {
//     const response = await dashboardService.genearateKpiTable(requestData);
//     dispatch({
//       type: GENERATE_KPI_TABLE,
//       payload: {
//         ...initialState?.apiStatus,
//         loader: false,
//         data: response?.data?.data,
//       },
//     });
//     return response;
//   } catch (error) {
//     dispatch({
//       type: GENERATE_KPI_TABLE,
//       payload: {
//         ...initialState.apiStatus,
//         loader: false,
//         message: errorMessage(error),
//         apiError: true,
//       },
//     });
//     throw error;
//   }
// };

export const genearateKpiTable = (data) => {
  return (dispatch) => {
    dispatch({
      type: GENERATE_KPI_TABLE,
      payload: { ...initialState, loading: true },
    });
    return dashboardService
      .genearateKpiTable(data)
      .then((res) => {
        dispatch({
          type: GENERATE_KPI_TABLE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: GENERATE_KPI_TABLE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error,
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error;
      });
  };
};

export const genearateKpiGrpah = (data) => {
  return (dispatch) => {
    dispatch({
      type: GENERATE_KPI_GRAPH,
      payload: { ...initialState, loading: true },
    });
    return dashboardService
      .genearateKpiGrpah(data)
      .then((res) => {
        dispatch({
          type: GENERATE_KPI_GRAPH,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: GENERATE_KPI_GRAPH,
          payload: {
            ...initialState,
            message: error?.response?.data?.error,
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const fetchDashboardFilteredBatchList =
  (payload) => async (dispatch) => {
    dispatch({
      type: FETCH_DASHBOARD_FILTERED_BATCH_LIST,
      payload: { ...initialState?.apiStatus, loading: true },
    });

    try {
      const response =
        await dashboardService.fetchDashboardFilteredBatchList(payload);
      dispatch({
        type: FETCH_DASHBOARD_FILTERED_BATCH_LIST,
        payload: {
          ...initialState.apiStatus,
          loading: false,
          data: response, // assumes response has `data`
        },
      });
      return response;
    } catch (error) {
      dispatch({
        type: FETCH_DASHBOARD_FILTERED_BATCH_LIST,
        payload: {
          ...initialState.apiStatus,
          loading: false,
          message: errorMessage(error),
          apiError: true,
        },
      });

      dispatch({
        type: FETCH_DASHBOARD_FILTERED_BATCH_LIST,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          data: []
        },
      });
      throw error;
    }
  };

export const fetchTablePlot = (payload) => async (dispatch) => {
  dispatch({
    type: FETCH_TABLE_PLOT_STATE,
    payload: {
      loader: true,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });

  try {
    const plotJson = await dashboardService.fetchTablePlot(payload);

    const hasValidData = (plotJson) => {
      if (!plotJson || typeof plotJson !== "object") {
        return false;
      }

      const hasInfo = plotJson?.info !== undefined && plotJson?.info !== null;
      const hasPlotData =
        plotJson?.plot_data !== undefined && plotJson?.plot_data !== null;

      return hasInfo && hasPlotData;
    };

    if (!hasValidData(plotJson)) {
      dispatch({
        type: FETCH_TABLE_PLOT_STATE,
        payload: {
          loader: false,
          error: true,
          message: "Something went wrong while fetching the plot.",
          data: null,
        },
      });
      return null;
    }

    // const isErrorResponse = plotJson?.status?.[0] >= 400 || plotJson?.body;

    // if (isErrorResponse) {
    //   let detailedError = "Something went wrong while fetching the plot.";

    //   try {
    //     const bodyJson = plotJson?.body?.[0]
    //       ? JSON.parse(plotJson.body[0])
    //       : null;

    //     if (bodyJson?.details)
    //       detailedError = `${detailedError} - ${bodyJson.details}`;
    //     else if (bodyJson?.error)
    //       detailedError = `${detailedError} - ${bodyJson.error}`;
    //   } catch (parseErr) {
    //     detailedError = "Something went wrong while fetching the plot.";
    //   }

    //   dispatch({
    //     type: FETCH_TABLE_PLOT_STATE,
    //     payload: {
    //       loader: false,
    //       error: true,
    //       message: detailedError,
    //       data: null,
    //     },
    //   });
    //   return;
    // }

    dispatch({
      type: FETCH_TABLE_PLOT_STATE,
      payload: { loader: false, data: plotJson, success: true, error: false },
    });
    return plotJson;
  } catch (err) {
    dispatch({
      type: FETCH_TABLE_PLOT_STATE,
      payload: {
        loader: false,
        error: true,
        message: errorMessage(err),
        data: null,
      },
    });
    // setTimeout(() => {
    //   dispatch({
    //     type: FETCH_TABLE_PLOT_STATE,
    //     payload: {
    //       loader: false,
    //       data: dummyData2,
    //       success: true,
    //       error: false,
    //     },
    //   });
    // }, 5000);
  }
};
